import React from 'react';

interface P { size?: number; }

// All icons: 24x24 viewBox, stroke-based, no fill
const props = (size: number) => ({
  width: size, height: size, viewBox: '0 0 24 24',
  fill: 'none', stroke: 'currentColor', strokeWidth: 1.8,
  strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
});

export const TrophyIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M8 21h8M12 17v4" />
    <path d="M7 4h10l-1.5 7A4.5 4.5 0 0 1 12 15a4.5 4.5 0 0 1-3.5-4L7 4Z" />
    <path d="M7 7H4a2 2 0 0 0 0 4l1.5.5M17 7h3a2 2 0 0 1 0 4l-1.5.5" />
  </svg>
);

export const StarIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
  </svg>
);

export const FlameIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M12 2C12 2 7 7.5 7 13a5 5 0 0 0 10 0C17 9 14 6 13 5c0 2.5-2 3.5-2 3.5C11 7 12 4 12 2Z" />
    <path d="M10 16c0-1.5 1-2.5 2-3" />
  </svg>
);

export const ChiliIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M12 20C8 20 5 17 5 13c0-3.5 3-7 6-9C13 6 16 9 16 13c0 4-1.5 7-4 7Z" />
    <path d="M12 4C12 4 13 2 15 2" />
    <path d="M9.5 14c0-1.5.5-3 2.5-3" />
  </svg>
);

export const LeafIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M5 20C5 20 4 11 10 7c4-2.5 9-1 9-1S17 12 11 15c-3 1.5-6 5-6 5Z" />
    <path d="M5 20c1-2.5 4-6 6-7.5" />
  </svg>
);

export const SproutIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M12 22V12" />
    <path d="M12 12C12 8 15 5 19 5c0 4-3 7-7 7Z" />
    <path d="M12 12C12 8 9 5 5 5c0 4 3 7 7 7Z" />
  </svg>
);

export const CrownIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M2 18h20M3 18l2-9 4.5 4.5L12 4l2.5 9.5L19 9l2 9" />
  </svg>
);

export const ChefHatIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M8 19h8M7 19v2h10v-2" />
    <path d="M7 19C5 19 4 17 4 15c0-1.5 1-3 2-3.5V10a6 6 0 0 1 12 0v1.5c1 .5 2 2 2 3.5 0 2-1 4-3 4" />
    <path d="M9 13h6" />
  </svg>
);

export const SparkleIcon: React.FC<P> = ({ size = 14 }) => (
  <svg {...props(size)}>
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2" />
    <path d="M5.64 5.64l1.42 1.42M16.95 16.95l1.41 1.41M5.64 18.36l1.42-1.42M16.95 7.05l1.41-1.41" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export type TagIconName =
  | 'trophy' | 'star' | 'flame' | 'chili' | 'leaf'
  | 'sprout' | 'crown' | 'chefhat' | 'sparkle';

export const TAG_ICON_MAP: Record<TagIconName, React.FC<P>> = {
  trophy:  TrophyIcon,
  star:    StarIcon,
  flame:   FlameIcon,
  chili:   ChiliIcon,
  leaf:    LeafIcon,
  sprout:  SproutIcon,
  crown:   CrownIcon,
  chefhat: ChefHatIcon,
  sparkle: SparkleIcon,
};
